function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { NativeSelect } from './NativeSelect';
import React, { useCallback, useMemo } from 'react';
import { components, default as ReactSelect } from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';
import styled from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import { theme } from '../styles';
import { shade, themify } from '../styles/mixins';
import { InputAddon, InputIcon, InputWrapper, Label } from './Input';
import { readableColor, rgba } from 'polished';
import Sync from '../icons/line/Sync';
import { Icon } from './Icon';

const customStyles = ({
  hasAddon,
  borderColor,
  highlightColor,
  fontSize
}) => ({
  control: (provided, state) => _objectSpread(_objectSpread(_objectSpread({}, provided), {}, {
    borderColor,
    borderRadius: 3,
    boxShadow: state.isFocused ? `0 0 0 1px ${highlightColor}` : 'none',
    height: state.isMulti ? 'auto' : '3em',
    fontSize: theme.type.scale[fontSize],
    flex: 1
  }, hasAddon ? {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  } : {}), {}, {
    ':hover': {
      borderColor: shade(0.8, borderColor)
    }
  }),
  indicatorsContainer: provided => _objectSpread(_objectSpread({}, provided), {}, {
    div: {
      padding: 6
    }
  }),
  indicatorSeparator: provided => _objectSpread(_objectSpread({}, provided), {}, {
    display: 'none'
  }),
  menu: provided => _objectSpread(_objectSpread({}, provided), {}, {
    borderRadius: '3px'
  }),
  menuList: provided => _objectSpread(_objectSpread({}, provided), {}, {
    padding: '3px 0'
  }),
  menuPortal: provided => _objectSpread(_objectSpread({}, provided), {}, {
    zIndex: theme.z.popover
  }),
  option: (provided, state) => _objectSpread(_objectSpread(_objectSpread({}, provided), {}, {
    backgroundColor: 'white',
    fontSize: theme.type.scale[fontSize],
    ':active': {
      background: state.isDisabled ? theme.colors.grayLight : highlightColor
    }
  }, !state.isDisabled ? {
    ':hover': {
      background: rgba(highlightColor, 0.25),
      color: readableColor(rgba(highlightColor, 0.25))
    }
  } : {}), state.isSelected ? {
    backgroundColor: highlightColor
  } : {}),
  placeholder: (provided, state) => _objectSpread(_objectSpread({}, provided), {}, {
    color: state.isDisabled ? theme.colors.gray : theme.colors.gray
  }),
  valueContainer: (provided, state) => _objectSpread(_objectSpread({}, provided), {}, {
    padding: state.isMulti ? '9px 6px' : '6px'
  })
}); // needed absolute for refetch icon


const SelectWrapper = styled.div.withConfig({
  displayName: "Select__SelectWrapper",
  componentId: "i718l8-0"
})(["position:relative;"]);
const RefetchIcon = styled(Icon).withConfig({
  displayName: "Select__RefetchIcon",
  componentId: "i718l8-1"
})(["position:absolute;top:50%;right:", ";z-index:", ";stroke:hsl(0,0%,80%);"], x => `calc(2em + ${x.$offset} * 2em)`, x => x.theme.z.popover);
export const Error = styled.span.withConfig({
  displayName: "Select__Error",
  componentId: "i718l8-2"
})(["float:right;color:", ";font-size:", ";"], x => x.theme.colors.red, x => x.theme.type.scale[6]);

const wrapInput = children => /*#__PURE__*/React.createElement(InputWrapper, null, children);

const isOptionDisabled = option => option.disabled === true;
/** Intended for hiding the remove button on fixed multi-select options */


const MultiValueRemove = props => {
  if (props.data.isFixed) {
    return null;
  }

  return /*#__PURE__*/React.createElement(components.MultiValueRemove, props);
};

const defaultFormatCreateLabel = value => `"${value}" toevoegen`;

const SelectFunc = (_ref) => {
  var _ref3;

  let {
    addonColor = 'grayLighter',
    addonContent,
    addonPadding = 1,
    addonSide = 'start',
    blurInputOnSelect = undefined,
    closeMenuOnSelect = undefined,
    borderColor = 'gray',
    className,
    clearable = undefined,
    color,
    defaultValue,
    disabled,
    error,
    fontSize = 5,
    highlightColor = 'green',
    icon,
    iconAnimation,
    iconColor = 'grayDarker',
    isMulti,
    id,
    label,
    labelColor = 'grayDark',
    labelSize = 6,
    loading,
    onChange,
    placeholder,
    innerRef,
    refetchOptions,
    useNativeSelect = false,
    options = [{
      value: '',
      label: 'You still need to add options',
      disabled: true
    }],
    name,
    touched,
    value,
    noOptionsMessage = 'Geen opties',
    creatable,
    onCreateOption,
    formatCreateLabel = defaultFormatCreateLabel
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["addonColor", "addonContent", "addonPadding", "addonSide", "blurInputOnSelect", "closeMenuOnSelect", "borderColor", "className", "clearable", "color", "defaultValue", "disabled", "error", "fontSize", "highlightColor", "icon", "iconAnimation", "iconColor", "isMulti", "id", "label", "labelColor", "labelSize", "loading", "onChange", "placeholder", "innerRef", "refetchOptions", "useNativeSelect", "options", "name", "touched", "value", "noOptionsMessage", "creatable", "onCreateOption", "formatCreateLabel"]);

  if (useNativeSelect) {
    if (rest.isClearable || rest.isDisabled || rest.isLoading || loading || rest.isSearchable) {
      console.warn("You're passing react-select props but are using the native <select/> element. Disable the `useNativeSelect` prop or remove the non-native props.");
    }
  }

  const handleNoOptionsMsg = useCallback(({
    inputValue
  }) => typeof noOptionsMessage === 'function' ? noOptionsMessage(inputValue) : noOptionsMessage, [noOptionsMessage]);
  const handleRefetch = useCallback(() => refetchOptions == null ? void 0 : refetchOptions(), [refetchOptions]);
  /** A unique ID randomly generated on mount. So in the case no `id` or `name` is passed along, the label always works as it should */

  const fallbackId = useMemo(() => Math.random().toString(36).substr(2, 5), []); // TODO: NEXT: This screws up SSR. When we use React 18, try this https://github.com/reactwg/react-18/discussions/111

  const hasAddon = !!(addonContent || icon);
  const renderWithAddon = useCallback((selectComp, side) => {
    if (!hasAddon) return selectComp;
    const AddonComponent = /*#__PURE__*/React.createElement(InputAddon, {
      $addonColor: themify(addonColor),
      $addonPadding: addonPadding,
      $addonSide: addonSide,
      $borderColor: themify(borderColor),
      $fontSize: fontSize,
      htmlFor: id || name || fallbackId,
      key: "selectAddon"
    }, icon ? /*#__PURE__*/React.createElement(InputIcon, {
      fill: themify(iconColor),
      icon: icon,
      iconAnimation: iconAnimation,
      solid: true,
      stroke: "none"
    }) : addonContent);
    if (side === 'end') return wrapInput([selectComp, AddonComponent]);
    return wrapInput([AddonComponent, selectComp]);
  }, [addonColor, addonContent, addonPadding, addonSide, borderColor, fallbackId, fontSize, hasAddon, icon, iconAnimation, iconColor, id, name]);
  const customComponents = useMemo(() => _objectSpread({
    SelectContainer: function CustomContainerComp(_ref2) {
      let {
        children
      } = _ref2,
          rest = _objectWithoutProperties(_ref2, ["children"]);

      return /*#__PURE__*/React.createElement(components.SelectContainer, rest, renderWithAddon(children, addonSide));
    },
    MultiValueRemove
  }, rest.components || []), [addonSide, renderWithAddon, rest.components]);
  const customStylesInstance = useMemo(() => customStyles({
    borderColor: themify(borderColor),
    highlightColor: themify(highlightColor),
    hasAddon: Boolean(addonContent || icon),
    fontSize
  }), [addonContent, borderColor, fontSize, highlightColor, icon]);
  const strLabel = typeof label === 'string' ? label : '';

  if (useNativeSelect && !isMulti) {
    if (label && typeof label !== 'string') {
      console.warn('Native select element label is not a string', label);
    }

    return /*#__PURE__*/React.createElement(NativeSelect, _extends({
      'aria-label': strLabel,
      'aria-labelledby': `${name}-label`,
      addonColor: addonColor,
      addonContent: addonContent,
      addonPadding: addonPadding,
      addonSide: addonSide,
      borderColor: borderColor,
      color: color,
      defaultValue: defaultValue,
      disabled: disabled,
      error: error,
      fontSize: fontSize,
      icon: icon,
      iconAnimation: iconAnimation,
      iconColor: iconColor,
      id: id || name || fallbackId,
      innerRef: innerRef,
      label: strLabel,
      labelColor: labelColor,
      labelSize: labelSize,
      onChange: onChange,
      options: options,
      placeholder: placeholder,
      touched: touched,
      value: value
    }, rest));
  }

  const isClearable = (_ref3 = clearable != null ? clearable : rest.isClearable) != null ? _ref3 : false;
  const hasOptionSelected = Boolean(value);

  const reactSelectProps = _objectSpread(_objectSpread({}, rest), {}, {
    key: 'selectInput',
    ariaLabel: label,
    ariaLabelledBy: `${id || name}-label`,
    styles: customStylesInstance,
    components: customComponents,
    inputId: id || name || fallbackId,
    isClearable: isClearable,
    isDisabled: disabled,
    isLoading: loading || rest.isLoading,
    isMulti,
    blurInputOnSelect,
    closeMenuOnSelect,
    isOptionDisabled,
    menuPortalTarget: typeof document !== 'undefined' ? document.body : undefined,
    name: name,
    onChange: onChange,
    // :shrug:
    openMenuOnFocus: rest.openMenuOnFocus || hasAddon,
    options: options,
    placeholder: placeholder || label,
    ref: innerRef,
    value: value,
    noOptionsMessage: handleNoOptionsMsg
  });

  return /*#__PURE__*/React.createElement(SelectWrapper, {
    className: className
  }, label && /*#__PURE__*/React.createElement(Label, {
    id: `${id || name}-label`,
    htmlFor: id || name || fallbackId,
    $fontSize: fontSize,
    $labelColor: themify(labelColor),
    $labelSize: labelSize
  }, label, touched && error && /*#__PURE__*/React.createElement(Error, null, error)), refetchOptions && !rest.isLoading && !loading && /*#__PURE__*/React.createElement(RefetchIcon, {
    icon: Sync,
    stroke: "grayDarker",
    hoverColor: "blue",
    onClick: handleRefetch,
    $offset: isClearable && hasOptionSelected ? 1 : 0
  }), creatable ? /*#__PURE__*/React.createElement(ReactSelectCreatable, _extends({}, reactSelectProps, {
    onCreateOption: onCreateOption,
    formatCreateLabel: formatCreateLabel
  })) : /*#__PURE__*/React.createElement(ReactSelect, reactSelectProps));
};

export const Select = withSpacing(SelectFunc, {
  mb: 1
});